import React, { useState, useEffect } from "react";
import {
  Button,
  Chip,
  IconButton,
  Avatar,
  List,
  Stack,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Card,
  useTheme,
  useMediaQuery
} from "@mui/material";
import PlaceholderImg from "../../assets/images/placeholder_img.jpg";
import moment from "moment";
import ErrorIcon from "@mui/icons-material/Error";
import {
  DELETE_BUY_SELL_USER_ITEMS,
  FETCH_BUY_SELL_USER_ITEMS,
  UPDATE_BUY_SELL_USER_ITEM_FOR_REPOST,
  UPDATE_EXPIRED_ITEMS
} from "../../constant/Apipath.jsx";
import Loader from "../../common/Loader.jsx";
import { useSelector } from "react-redux";
import { English } from "../../constant/EnglishFallback.jsx";
import { Postrequestcall } from "../../request/Postrequest.jsx";
import AddListing from "./AddListing";
import { useLocation, useNavigate } from "react-router-dom";
import Pageheader from "../common/Pageheader";
import Emptydata from "../common/Emptydata";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import DeleteConfirmation from "../common/DeleteConfirmation";
const MyListings = () => {
  const { loginData, multiLanguageData } = useSelector((state) => state?.main);

  // Language data
  const LanguageData = multiLanguageData?.BuySell || {};
  const {
    TEXT_HEADER_BUY_SELL = English.BuySell.TEXT_HEADER_BUY_SELL,
    TEXT_HEADER_MY_LISTING_PAGE = English.BuySell.TEXT_HEADER_MY_LISTING_PAGE,
    TEXT_FOR_TRADE_BADGE = English.BuySell.TEXT_FOR_TRADE_BADGE,
    TEXT_BACK_TO_MARKETPLACE = English.BuySell.TEXT_BACK_TO_MARKETPLACE,
    TEXT_POST_NEW_LISTING = English.BuySell.TEXT_POST_NEW_LISTING,
    TEXT_NO_LISTINGS_YET = English.BuySell.TEXT_NO_LISTINGS_YET,
    TEXT_CREATE_FIRST_LISTING = English.BuySell.TEXT_CREATE_FIRST_LISTING,
    TEXT_ACTIVE_LISTINGS = English.BuySell.TEXT_ACTIVE_LISTINGS,
    TEXT_EXPIRED_LISTINGS = English.BuySell.TEXT_EXPIRED_LISTINGS,
    TEXT_EXPIRED_CHIP = English.BuySell.TEXT_EXPIRED_CHIP,
    TEXT_EXPIRES_IN = English.BuySell.TEXT_EXPIRES_IN,
    TEXT_DAYS = English.BuySell.TEXT_DAYS,
    TEXT_REPOST = English.BuySell.TEXT_REPOST
  } = LanguageData;
  let currentUserId = loginData?.userInformation?.UserId ?? 0;
  const [activeItem, setActiveItem] = useState([]);
  const [expiredItem, setExpiredItem] = useState([]);
  const [deleteAlertModal, setDeleteAlertModal] = useState(false);
  const [selectItemDetails, setSelectedItemDetails] = useState(null);
  const [showAddListingModal, setShowAddListingModal] = useState(false);
  const [editListItemDetails, setEditListItemDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const location = useLocation();
  const navigate = useNavigate();

  const headerName = location.pathname === "/buy-sell/my-listing" ? TEXT_HEADER_MY_LISTING_PAGE : TEXT_HEADER_BUY_SELL;
  useEffect(() => {
    getData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getData = async () => {
    setIsLoading(true);
    try {
      const obj = {
        NrOfRecPerPage: 20,
        FullSearch: "",
        UserId: Number(currentUserId),
        IncludeRecordNr: true,
        TypeOfObjectReturned: "",
        FetchAllowedRecordsOnly: true,
        SearchList: [{ ModifiedBy: Number(currentUserId) }],
        SortList: [{ FieldName: "Id", Direction: "DESC" }]
      };
      const res = await Postrequestcall(FETCH_BUY_SELL_USER_ITEMS, obj, loginData?.accessToken);
      res?.data?.data?.map(async (i) => {
        const obj2 = {
          Id: i.id,
          ModifiedBy: Number(currentUserId)
        };
        await Postrequestcall(UPDATE_EXPIRED_ITEMS, obj2, loginData?.accessToken);
      });
      const res3 = await Postrequestcall(FETCH_BUY_SELL_USER_ITEMS, obj, loginData?.accessToken);
      const isActiveItems = res3?.data?.data?.filter((i) => !i.isExpired);
      const isExpiredItems = res3?.data?.data?.filter((i) => i.isExpired);
      setActiveItem(isActiveItems);
      setExpiredItem(isExpiredItems);
      setIsLoading(false);
    } catch (error) {
      console.log("GetData -> Error When Fetching Buy Sell Items :", error?.message ?? error);
      setIsLoading(false);
    }
  };

  const onDeletePressed = (item) => {
    setSelectedItemDetails(item);
    setDeleteAlertModal(true);
  };

  const onDeleteListingPressed = async () => {
    try {
      const obj = {
        UserId: Number(currentUserId),
        ReturnRecordId: false,
        ReturnRecordError: true,
        SoftDelete: true,
        DeleteList: [
          {
            Id: selectItemDetails?.id,
            ModifiedBy: Number(currentUserId)
          }
        ]
      };
      await Postrequestcall(DELETE_BUY_SELL_USER_ITEMS, obj, loginData?.accessToken);
      getData();
      setSelectedItemDetails(null);
      setDeleteAlertModal(false);
    } catch (e) {
      setSelectedItemDetails(null);
      setDeleteAlertModal(false);
      console.log("onDeleteListingPressed-> Error When Deleting Listing ", e);
    }
  };

  const onRepostClick = async (item) => {
    try {
      setSelectedItemDetails(item);
      const obj = {
        Id: item.id
      };
      await Postrequestcall(UPDATE_BUY_SELL_USER_ITEM_FOR_REPOST, obj, loginData?.accessToken);
      await getData();
      setSelectedItemDetails(null);
    } catch (e) {
      setSelectedItemDetails(null);
      console.log("onRepostClick -> Error When Reposting: ", e);
    }
  };

  const onAddMyListingPressed = () => {
    return setShowAddListingModal(true);
  };

  const onEditItemClick = async (item) => {
    setEditListItemDetails(item);
    return setShowAddListingModal(true);
  };

  const getDate = (item) => {
    if (!item?.expiryDate || item?.expiryDate === "null") {
      return null;
    }
    const expiryDate = moment(item.expiryDate);
    if (!expiryDate.isValid()) {
      return null;
    }
    const currentDate = moment();
    return expiryDate.diff(currentDate, "days");
  };

  const getSellItem = (item) => {
    return (
      <Stack direction="row" spacing={1} alignItems="center">
        <IconButton
          size="small"
          onClick={(e) => { e.stopPropagation(); onEditItemClick(item); }}
          sx={{ bgcolor: "#eff6ff", color: "#3b82f6", "&:hover": { bgcolor: "#dbeafe" } }}
        >
          <EditIcon fontSize="small" />
        </IconButton>
        <IconButton
          size="small"
          onClick={(e) => { e.stopPropagation(); onDeletePressed(item); }}
          sx={{ bgcolor: "#fef2f2", color: "#ef4444", "&:hover": { bgcolor: "#fee2e2" } }}
        >
          <DeleteIcon fontSize="small" />
        </IconButton>
        {item?.isExpired && (
          <Button
            startIcon={<AutorenewIcon />}
            variant="contained"
            size="small"
            onClick={(e) => { e.stopPropagation(); onRepostClick(item); }}
            sx={{
              textTransform: "none",
              borderRadius: "8px",
              bgcolor: "#3b82f6",
              "&:hover": { bgcolor: "#2563eb" }
            }}
          >
            {TEXT_REPOST}
          </Button>
        )}
      </Stack>
    );
  };

  const renderMyList = (itemList) => {
    return (
      <Stack spacing={2}>
        {itemList?.map((item, index) => (
          <Card
            key={item.id || index}
            sx={{
              borderRadius: "16px",
              border: "1px solid #f1f5f9",
              boxShadow: "none",
              transition: "transform 0.2s, box-shadow 0.2s",
              "&:hover": {
                transform: "translateY(-2px)",
                boxShadow: "0 4px 6px -1px rgb(0 0 0 / 0.1)",
                borderColor: "#e2e8f0"
              },
              cursor: "pointer",
              p: 2
            }}
            onClick={() => onEditItemClick(item)}
          >
            <Stack direction="row" spacing={2} alignItems="center">
              <Avatar
                variant="rounded"
                src={item?.pictureList?.length !== 0 ? item?.pictureList?.[0].name : PlaceholderImg}
                sx={{ width: 80, height: 80, borderRadius: "12px" }}
              />
              <Box sx={{ flexGrow: 1 }}>
                <Typography variant="subtitle1" fontWeight={700} color="#1e293b" noWrap>
                  {item?.title}
                </Typography>
                <Stack direction="row" spacing={1} alignItems="center" mt={0.5}>
                  <Typography variant="body2" fontWeight={600} color="#3b82f6">
                    {item.forTrade ? TEXT_FOR_TRADE_BADGE : `$${item?.price?.toLocaleString()}`}
                  </Typography>
                  {item?.expiryDate && item?.expiryDate !== "null" && getDate(item) !== null &&<Typography variant="caption" color="text.secondary">
                    •
                  </Typography>}
                  {item.isExpired ? (
                    <Chip
                      label={TEXT_EXPIRED_CHIP}
                      size="small"
                      icon={<ErrorIcon sx={{ fontSize: "14px !important" }} />}
                      sx={{ height: 20, bgcolor: "#fee2e2", color: "#ef4444", fontWeight: 600, border: "1px solid #fecaca" }}
                    />
                  ) : (
                    item?.expiryDate && item?.expiryDate !== "null" && getDate(item) !== null ? (
                      <Typography variant="caption" color="#10b981" fontWeight={600}>
                        {TEXT_EXPIRES_IN} {getDate(item)} {TEXT_DAYS}
                      </Typography>
                    ) : null
                  )}
                </Stack>
              </Box>
              <Box>
                {getSellItem(item)}
              </Box>
            </Stack>
          </Card>
        ))}
      </Stack>
    );
  };

  return (
    <Box className="main-content-Box" sx={{ p: isSmallScreen ? 1.5 : 3 }}>
      <Pageheader headerName={headerName} />

      {isLoading ? (
        <Loader />
      ) : (
        <Box sx={{ mt: 2 }}>
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="center"
            mb={3}
            sx={{ bgcolor: "white", p: 2, borderRadius: "16px", boxShadow: "0 1px 3px 0 rgb(0 0 0 / 0.1)" }}
          >
            <Button
              variant="text"
              onClick={() => navigate("/buy-sell")}
              startIcon={<ArrowBackIcon />}
              sx={{ textTransform: "none", fontWeight: 600, color: "text.secondary" }}
            >
              {TEXT_BACK_TO_MARKETPLACE}
            </Button>
            <Button
              variant="contained"
              disableElevation
              onClick={onAddMyListingPressed}
              sx={{
                borderRadius: "12px",
                textTransform: "none",
                px: 3,
                fontWeight: 600,
                bgcolor: "#3b82f6",
                "&:hover": { bgcolor: "#2563eb" }
              }}
            >
              {TEXT_POST_NEW_LISTING}
            </Button>
          </Stack>

          <Box id="scrollablediv_prodcut">
            {activeItem?.length === 0 && expiredItem?.length === 0 ? (
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  py: 10,
                  bgcolor: "white",
                  borderRadius: "24px",
                  border: "1px dashed #e2e8f0"
                }}
              >
                <Emptydata
                  icon={<BusinessCenterIcon sx={{ fontSize: 64, color: "#e2e8f0" }} />}
                  firstText={TEXT_NO_LISTINGS_YET}
                />
                <Button variant="contained" onClick={onAddMyListingPressed} sx={{ mt: 3, borderRadius: "12px" }}>
                  {TEXT_CREATE_FIRST_LISTING}
                </Button>
              </Box>
            ) : (
              <Stack spacing={4}>
                {activeItem?.length > 0 && (
                  <Box>
                    <Typography variant="h6" fontWeight={700} mb={2} color="#1e293b">
                      {TEXT_ACTIVE_LISTINGS} ({activeItem.length})
                    </Typography>
                    {renderMyList(activeItem)}
                  </Box>
                )}

                {expiredItem?.length > 0 && (
                  <Box>
                    <Typography variant="h6" fontWeight={700} mb={2} color="#ef4444">
                      {TEXT_EXPIRED_LISTINGS} ({expiredItem.length})
                    </Typography>
                    {renderMyList(expiredItem)}
                  </Box>
                )}
              </Stack>
            )}
          </Box>
        </Box>
      )}

      <DeleteConfirmation
        open={deleteAlertModal}
        onClose={() => setDeleteAlertModal(false)}
        secondaryText="Are you sure you want to delete this Listing? This action cannot be undone."
        onBadgeClick={() => onDeleteListingPressed()}
        actionBtnText="Delete Listing"
      />
      {showAddListingModal && (
        <AddListing
          open={showAddListingModal}
          onClose={() => {
            setSelectedItemDetails(null);
            setEditListItemDetails(null);
            setShowAddListingModal(false);
          }}
          getUpdatedData={getData}
          editListItemDetails={editListItemDetails}
        />
      )}
    </Box>
  );
};

export default MyListings;
